<template>
  <div id="layListZh">
    <div class="left_TitleZh">
      <p>
        <i class="iconfont iconjieguo"></i>
        <span>{{ '搜索结果' + '&nbsp;' + '(' + total + ')' }}</span>
      </p>
      <p></p>
    </div>
    <div v-if="!isNo" class="list_Content aqt_no_su" ref="Content_Width">
      <div class="aqt_list_lists_one" v-for="(item,index) in list" :key="index"
           @click.stop="getDetail(item.book_id,item.isxq,item)">
        <div class="aqt_top aqt_ce_ve">
          <img v-lazy="item.imgm?$webcrypto.get(item.imgm):''" alt/>
          <div v-show="item.annexcount>0" class="label">PDF</div>
          <div v-if="item.isaudiobook==2" class="ListenBooks">
            <i class="iconfont icontingshu"></i>
          </div>
        </div>
        <div class="aqt_center">
          <!-- 蒙语标题 -->
          <div class="aqt_title">
            <p v-html="item.namelang? (item.namelang.zh||item.namelang.en) : '暂无数据'"></p>
          </div>
          <!--出版社-->

          <div class="aqt_zhengzhuang pressName">
            <img src="../../assets/images/info_book.png" alt/>
            <p @click.stop="getPress(item.presslang ?( item.presslang.zh|| item.presslang.en) :'',item.press_id)"
               style="cursor: pointer"
               class="contentfonts1"
               v-html="item.presslang?(item.presslang.zh||item.presslang.en):'暂无数据'"></p>

          </div>
          <!--作者-->
          <div class="aqt_zhengzhuang">
            <img src="../../assets/images/info_people.png" alt/>
            <p class="contentfonts1"
               v-html="item.authorlang?(item.authorlang.zh||item.authorlang.en):'暂无数据'"></p>
          </div>
          <!--出版时间-->
          <div class="aqt_zhengzhuang">
            <img src="../../assets/images/pubulish.png" alt/>
            <p class="contentfonts1">{{ item.publish_date ? item.publish_date : '暂无数据' }}</p>
          </div>
        </div>
        <div class="aqt_bottom_img">
          <img src="@/assets/images/detail_right.png">
        </div>
      </div>
    </div>
    <div class="page">
      <Page v-if="!isNo" :total="total" :current="current_page"
            :page-size="per_page"
            @on-change="getPager"/>
    </div>
    <div v-if="isNo&&!list.length" class="nomassage">
      <p>暂无数据</p>
    </div>
    <!--    加载动画-->
    <AqtSpin v-if="isSpin" :bottom="'92px'" :height="'100%'"></AqtSpin>
  </div>
</template>
<script>
export default {
  data() {
    return {
      total: 0,
      current_page: 1,
      per_page: 0,
      list: [],
      isNo: false,
      booksSearch: {
        name: '',//书名
        isbn: '',//书号
        press_name: '',//出版社名称
        author: '',//作者名称
        content: '',//简介
        publish_date_chu: '',//出版时间
        press_id: '',//出版社id
        culture_id: '',//文化分类
        resourceclass_id: '',//资源分类(经典分类)
        lang: 'zh',
        page: 1,
        per_page: '',
        library_id: '',
        subject:'',//关键词
        book_type:'',//图书分类

      },
      isSpin: false,
      isSpin_press: false,
      pressData: {
        name: '',//出版社名称
        address: '',//详细地址
        content: '',//出版社简介
        address_name: '',//地区
      },
    }
  },
  methods: {
    /******************************************
     *
     *分页器
     *
     *****************************************/
    getPager(page) {
      let that = this
      that.list = []
      that.booksSearch.page = page
      that.getList()
    },
    getList() {
      let that = this
      that.isSpin = true
      that.list = []
      that.booksSearch.library_id = that.library_id
      //保存用户搜索记录
      if (that.booksSearch.page == 1) {
        that.$store.commit('SET_PuserSearch', [JSON.stringify(that.booksSearch), that.$route.path, that.$route.meta.title, 1],)
        that.$store.dispatch('getHedcircle')
      }
      that.$httpsencrypt.post(`api/web/v3/book/newlistpc`, that.booksSearch)
          .then((val) => {
            if (val.code == 200 && val.data.length) {
              that.total = val.pages.total
              that.current_page = val.pages.current_page
              that.per_page = val.pages.per_page * 1

              if (that.booksSearch.name) {
                val.data.forEach((item) => {
                  var arr = item.namelang && item.namelang.zh ? item.namelang.zh.split(" ") : [];
                  if (arr.length) {
                    arr.forEach((elem, index) => {
                      var strarr = that.booksSearch.name.split(' ')
                      strarr.forEach(it => {
                        if (it == '') {
                          return
                        }
                        var i = elem.indexOf(it.trim());

                        if (i > -1) {
                          var replacestr =
                              '<span style="color:var(--themeColor)!important;">' +
                              arr[index] +
                              "</span>";
                          arr[index] = replacestr;
                        }

                      })
                    });
                    item.namelang.zh = arr.join(" ");
                  }
                });
              } else if (that.booksSearch.press_name) {
                val.data.forEach((item) => {
                  var arr = item.presslang && item.presslang.zh ? item.presslang.zh.split(" ") : [];
                  if (arr.length) {
                    arr.forEach((elem, index) => {
                      var strarr = that.booksSearch.press_name.split(' ')
                      strarr.forEach(it => {
                        if (it == '') {
                          return
                        }
                        var i = elem.indexOf(it.trim());
                        if (i > -1) {
                          var replacestr =
                              '<span style="color:var(--themeColor)">' +
                              arr[index] +
                              "</span>";
                          arr[index] = replacestr;
                        }

                      })
                    });
                    item.presslang.zh = arr.join(" ");
                  }
                });
              } else if (that.booksSearch.author) {
                val.data.forEach((item) => {
                  var arr = item.author && item.authorlang.zh ? item.authorlang.zh.split(" ") : [];
                  if (arr.length) {
                    arr.forEach((elem, index) => {
                      var strarr = that.booksSearch.author.split(' ')
                      strarr.forEach(it => {
                        if (it == '') {
                          return
                        }
                        var i = elem.indexOf(it.trim());

                        if (i > -1) {
                          var replacestr =
                              '<span style="color:var(--themeColor)!important;">' +
                              arr[index] +
                              "</span>";
                          arr[index] = replacestr;
                        }

                      })
                    });
                    item.authorlang.zh = arr.join(" ");
                  }
                });
              }
              that.list = val.data
              that.isSpin = false
              that.isNo = false
            } else {
              that.list = []
              that.isNo = true
              that.isSpin = false
              that.total = 0
            }
          }).catch(e => {
            that.list = []
            that.isNo = true
            that.isSpin = false
            that.total = 0
          }
      )
    },
    getDetail(id, isxq, item) {
      let that = this
      if (isxq == 0) {
        that.$Message.warning({
          render: h => {
            return h('div', {
              style: {
                writingMode: 'vertical-lr'
              }
            }, '没有权限，请使用移动端查阅')
          },
        });
        return
      }
      that.$store.dispatch('saveUserBehavior', {
        type: 1,
        path: that.$route.path,
        mark: '点击' + (item.namelang.zh || item.namelang.en)
      }).then(() => {
      })

      let cond = {
        id: id
      }
      that.$emit('getToDeatils', cond, 'BookDetails')


    },
    //  显示出版社数据
    getPress(val, id) {
      let that = this
      let data = {
        data: val.replace(/<\/?(span)[^>]*>/gi, ''),
        id: id
      }
      that.$emit('pushTele', data)
    },
    //父组件调用请求数组
    ParentCom(val) {
      let that = this
      that.isNo = false
      that.booksSearch.name = val.name
      that.booksSearch.isbn = val.isbn
      that.booksSearch.press_name = val.press_name
      that.booksSearch.author = val.author
      that.booksSearch.content = val.content
      that.booksSearch.publish_date_chu = val.publish_date_chu
      that.booksSearch.press_id = val.press_id
      that.booksSearch.culture_id = val.culture_id
      that.booksSearch.resourceclass_id = val.resourceclass_id
      that.booksSearch.subject = val.subject
      that.booksSearch.book_type = val.book_type
      that.getList()
    },
  },

  created() {
    let info = {
      type: 1,
      path: this.$route.path,
      mark: '书籍列表',
    }
    this.$store.dispatch('saveUserBehavior', info).then(() => {
    })
  },
  mounted() {
    let that = this
    let kk = (that.$refs.Content_Width.clientHeight - 107) / 120.2
    that.booksSearch.per_page = Math.floor(kk)
    that.booksSearch.page = 1

  },
  computed: {
    // 馆藏id
    library_id() {
      let vv = localStorage.getItem("theme_color") ?
          JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))).library_id ?
              JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))).library_id : 28 : 28
      return vv
    },
    member_id() {
      let vv = localStorage.getItem("userInfoMemberId") ? JSON.parse(this.$crypto.get(localStorage.getItem("userInfoMemberId"))).member_id : ''
      return vv
    },
    library_infor: {
      get: function () {
        let myDate = localStorage.getItem("theme_color") ?
            JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))) : ''
        return myDate;
      },
      set: function (newValue) {
        return newValue;
      },
    }
  },


}
</script>
<style lang="less" scoped>
#layListZh {
  width: 100%;
  height: 100%;
  position: relative;
  overflow-y: hidden;

  .contentfonts1 {
    font-size: 1.6rem;
  }

  .nomassage {
    width: 100%;
    padding: 0 1rem;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    display: -ms-flexbox;
    display: flex;
    font-size: 2rem;
    color: #888888;
    justify-content: center;
  }

  .left_TitleZh {
    height: 54px;
    width: 100%;
    background: #ffffff;
    margin-bottom: 2px;
    padding-right: 27px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    p:nth-child(1) {
      height: 24px;
      color: var(--themeColor);
      font-size: 20px;
      line-height: 24px;

      i {
        font-size: 24px;
      }
    }

    p:nth-child(2) {
      height: 8px;
      width: 162px;
      background: var(--themeColor);
      margin-top: 10px;
    }
  }

  .list_Content {
    width: 100%;
    //height: calc(100% - 210px);
    height: calc(100% - 99px);
    overflow-y: auto !important;
    overflow-x: hidden;
    padding-top: 0.2rem;

    .aqt_list_lists_one {
      height: 120px;
      width: 100%;
      background-color: #ffffff;
      margin-bottom: 0.2rem;
      display: flex;
      cursor: pointer;

      .aqt_top {
        width: 85px;
        height: calc(100% - 16px);
        position: relative;
        margin: 8px 10px;
        box-shadow: rgb(136, 136, 136) 1px 1px 6px;
        overflow: hidden;

        .label {
          line-height: 24px;
          height: 20px;
          background: red;
          color: #fff;
          font-size: 12px;
          position: absolute;
          right: 0;
          top: 0;
          z-index: 2;
          padding: 0 15px;
          -webkit-transform-origin: left bottom;
          -moz-transform-origin: left bottom;
          transform-origin: left bottom;
          -webkit-transform: translate(29.29%, -100%) rotate(45deg);
          -moz-transform: translate(29.29%, -100%) rotate(45deg);
          transform: translate(29.29%, -100%) rotate(45deg);
          text-indent: 0;
        }

        .ListenBooks {
          height: 30px;
          width: 16px;
          border-radius: 2px;
          color: #FFFFFF;
          background: rgba(0, 0, 0, 0.35);
          position: absolute;
          border: 3px;
          left: 3px;
          display: flex;
          justify-content: center;
          align-items: center;

          i {
            font-size: 18px;
          }
        }

        img {
          width: 100%;
          height: 100%;
        }

        img[lazy="loading"] {
          height: auto !important;
        }
      }

      .aqt_center {
        height: 100%;
        width: calc(100% - 145px);
        padding-top: 1rem;


        .aqt_title {
          height: 3.4rem;
          width: calc(100% - 1rem);
          color: #888888;
          font-size: 1.8rem;

          p {
            white-space: nowrap;
            -o-text-overflow: ellipsis;
            text-overflow: ellipsis;
            overflow: hidden;
            margin: 0 auto;
            width: 100%;
          }
        }


        .aqt_zhengzhuang {
          width: 100%;
          height: calc(calc(100% - 3.4rem) / 3);
          color: #888888;
          font-size: 1.6rem;
          white-space: nowrap;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
          overflow: hidden;
          line-height: 1.6rem;
          padding-right: 12px;
          display: flex;


          img {
            width: 1.6rem;
            height: 1.6rem;
            margin-right: 0.5rem;
          }
        }

        .pressName:hover {
          p {
            color: #FFB600 !important;

            span {
              color: #FFB600 !important;
            }
          }

        }
      }

      .aqt_bottom_img {
        height: 100%;
        width: 40px;

        img {
          height: 100%;
          width: 100%;
        }
      }
    }

    .aqt_list_lists_one:hover {
      background: rgba(255, 255, 255, 0.3);

      .aqt_title {
        color: var(--themeColor);
      }

      .aqt_zhengzhuang {
        color: var(--themeColor);
      }

      .pressName {
        color: var(--themeColor);
      }
    }
  }

  .list_Content::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
  }

  .list_Content::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .list_Content::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

  .page {
    height: 45px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>

